import { cssLoaderURL, mainScriptURL } from 'javascript/Constants'
import { useAppStore } from 'Store/app'
import { useColorsStore } from 'Store/colors'
import { hexToRgb } from 'Utilities/color'
import { definePropertySafe } from 'Utilities/definePropertySafe'

const materialSymbolsCssUrl =
  'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200'

function _addLinkCSSToIframeDoc(iframeDoc, URL) {
  return new Promise((resolve, reject) => {
    const style = document.createElement('link')
    style.rel = 'stylesheet'
    style.href = URL
    style.onload = resolve
    style.onerror = reject
    iframeDoc.head.appendChild(style)
  })
}
function _addScriptToIframeDoc(iframeDoc, URL) {
  return new Promise((resolve, reject) => {
    const scriptElm = document.createElement('script')
    scriptElm.src = URL
    scriptElm.onload = resolve
    scriptElm.onerror = reject
    iframeDoc.head.appendChild(scriptElm)
  })
}

function _addGoogleFontsToIframeDoc(iframeDoc) {
  const link1 = document.createElement('link')
  link1.rel = 'preconnect'
  link1.href = 'https://fonts.gstatic.com'

  const link2 = document.createElement('link')
  link2.rel = 'preconnect'
  link2.href = 'https://fonts.gstatic.com" crossorigin'
  link2.crossOrigin = true

  const link3 = document.createElement('link')
  link3.rel = 'stylesheet'
  link3.href = 'https://fonts.googleapis.com/css2?family=Mulish:wght@400;600;700&display=swap'

  iframeDoc.head.appendChild(link1)
  iframeDoc.head.appendChild(link2)
  iframeDoc.head.appendChild(link3)
}

function appendHotelCode(url, hotelCode) {
  const result = new URL(url)
  result.searchParams.set('code', hotelCode)

  return result.toString()
}

export default function (iframe, vueAppID, locale, iframeType = '', hotelCode) {
  const appStore = useAppStore()
  const colorsStore = useColorsStore()
  const vipFacilities = process.env.VIP_FACILITIES?.split(',') || []
  const isVIP = vipFacilities.includes(hotelCode)

  const iframeDoc = iframe.contentDocument || iframe.contentWindow.document
  const iframeWin = iframe.contentWindow
  iframeWin.Object.definePropertySafeSafe = definePropertySafe

  iframeDoc.documentElement.lang = locale
  const metaViewport = iframeDoc.createElement('meta')
  metaViewport.content = 'width=device-width, initial-scale=1'
  metaViewport.name = 'viewport'
  iframeDoc.head.appendChild(metaViewport)

  _addGoogleFontsToIframeDoc(iframeDoc)

  const divComponent = iframeDoc.createElement('div')
  divComponent.id = vueAppID

  iframeDoc.body.appendChild(divComponent)

  colorsStore.$subscribe((mutation, state) => {
    const { r, g, b } = hexToRgb(state.themeColor)
    const themeRgbColor = `${r}, ${g}, ${b}`
    iframeDoc.documentElement.style.setProperty('--tripla-theme-color', state.themeColor)
    iframeDoc.documentElement.style.setProperty('--tripla-text-color', state.textColor)
    iframeDoc.documentElement.style.setProperty('--tripla-theme-rgb', themeRgbColor)
  })

  if (vueAppID === 'chatwindow-app') {
    _addLinkCSSToIframeDoc(iframeDoc, materialSymbolsCssUrl)
  }

  Promise.all([
    _addScriptToIframeDoc(iframeDoc, isVIP ? appendHotelCode(cssLoaderURL, hotelCode) : cssLoaderURL),
    _addScriptToIframeDoc(iframeDoc, isVIP ? appendHotelCode(mainScriptURL, hotelCode) : mainScriptURL)
  ]).then(() => {
    appStore.appendIframeHasLoadedCSS(vueAppID)
  })

  if (['icon', 'icon-message'].indexOf(iframeType) > -1) {
    iframeDoc.body.style.backgroundColor = 'transparent'
  }
}
